// Copyright (c) 2016 Deere & Company

import PipCode, {getDefaultState as getPipCodeDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pip-code';

export const getDefaultState = () => getPipCodeDefaultState();

export default PipCode;



// WEBPACK FOOTER //
// ./src/pip/pip-code/state/pip-code.js